import "core-js/modules/es.number.constructor.js";
import { leadingZero } from '@/shared/lib/utils/numberFormatters';
import CProgressLinear from '@/shared/ui/CProgressLinear.vue';
export default {
  name: 'StatusLine',
  components: {
    CProgressLinear: CProgressLinear
  },
  props: {
    steps: {
      type: Number,
      default: 0
    },
    currentStep: {
      type: Number,
      default: 0
    },
    label: {
      type: String,
      default: undefined
    }
  },
  computed: {
    progressValue: function progressValue() {
      return Math.round(this.currentStep * 100 / (this.steps ? this.steps : 1));
    },
    finalProgressValue: function finalProgressValue() {
      return this.progressValue ? this.progressValue : 0;
    }
  },
  methods: {
    leadingZero: leadingZero
  }
};